import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Change_Class_Active_State } from '../../../actions/class';
import { Modal, Button, Alert } from 'react-bootstrap';
import { HomePage } from '../../../translations/trans';

function DeactivateClass({ classId,userId }) {
    const [showModal, setShowModal] = useState(false);
    const [response, setResponse] = useState(null);
    const dispatch = useDispatch();

    const handleDeactivate = async () => {
        try {
            const res = await dispatch(Change_Class_Active_State({ id: classId, active: false,userId}));
            setResponse(res.data.case);
            handleClose();
        } catch (error) {
            console.error('Error:', error);
        }
        // setShowModal(false);
    };

    const handleClose = () => {
        setShowModal(false);
        setResponse(null);
    };

    const handleShow = () => setShowModal(true);

    const { lang, dir } = useSelector(({ language }) => {
        return { lang: language.lang, dir: language.dir };
    });


    return (
        <div>
            {/* <Button variant="danger" >
                تعطيل
            </Button> */}
            <button className='btn w-100' onClick={handleShow} style={{ backgroundColor: "#D43B43" }}>
                {HomePage.deactive[lang]}
            </button>

            <Modal show={showModal} onHide={handleClose} dir={dir}>
                <Modal.Header closeButton>
                    <Modal.Title>{HomePage.Confirmation[lang]}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {HomePage.deactiveClass[lang]}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {HomePage.cancel[lang]}
                    </Button>
                    <Button variant="danger" onClick={handleDeactivate}>
                        {HomePage.deactive[lang]}
                    </Button>
                </Modal.Footer>
            </Modal>

            {response && (
                <Alert variant={response ? 'success' : 'danger'} onClose={() => setResponse(null)} dismissible>
                    {response ? 'Class deactivated successfully' : 'Failed to deactivate class'}
                </Alert>
            )}
        </div>
    );
}

export default DeactivateClass;
